import { render, staticRenderFns } from "./ReviewElement.vue?vue&type=template&id=13107d28&scoped=true&"
import script from "./ReviewElement.vue?vue&type=script&lang=js&"
export * from "./ReviewElement.vue?vue&type=script&lang=js&"
import style0 from "./ReviewElement.vue?vue&type=style&index=0&id=13107d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13107d28",
  null
  
)

export default component.exports